const SettingContanst = {
  custom_landing_page:"custom_landing_page"
}

export  default SettingContanst